import { useNavigate, useRouteError } from 'react-router-dom'
import { Button, NoticeText } from '@unimpaired/react'
import {
  faArrowLeft,
  faHome,
  faRefresh,
} from '@fortawesome/free-solid-svg-icons'
import { ApplicationRoutes } from '@unimpaired/utils'

type Props = {
  goBackPath?: ApplicationRoutes
  goBackText?: string
}

export const NotFoundPage = ({ goBackPath, goBackText }: Props) => {
  const error = useRouteError() as
    | { message: string }
    | { response: { data: any } }
  const navigateTo = useNavigate()
  const getMessage = () => {
    if (!error) return 'Page not found'
    if ('response' in error) {
      return error.response.data.message
    }
    if ('message' in error) return error.message
    return 'Page not found'
  }

  return (
    <div className='bg-base-100 text-base-1000 grid px-6 py-24 sm:py-32 lg:px-8 h-screen w-full overflow-hidden'>
      <div className='text-center'>
        <p className='text-base font-semibold'>404</p>
        <h1 className='mt-4 text-3xl font-bold tracking-tight'>
          {getMessage()}
        </h1>
        <p className='mt-6 text-base leading-7 text-base-800'>
          There was an issue with your request
        </p>
        <NoticeText
          className='mx-auto mt-4'
          type='info'
          text='Sometimes, a quick refresh is all it takes to fix it :)'>
          <Button
            icon={faRefresh}
            variant='raised'
            onClick={() => {
              window.location.reload()
            }}>
            Refresh
          </Button>
        </NoticeText>
        <div className='mt-10 flex items-center justify-center gap-x-6'>
          <Button
            // variant='raised'
            onClick={() => navigateTo(-1)}
            icon={faArrowLeft}>
            Go Back
          </Button>
          <Button
            // variant='raised'
            icon={faHome}
            to={goBackPath || '/'}>
            Go Home
          </Button>
        </div>
      </div>
    </div>
  )
}
